import React, { useRef, useState } from "react";
import { Cookies } from "react-cookie";
import { Div, FlexRow, FlexColumn, Divider, Spacer } from "../../../core/Containers";
import { LBCModal } from "../../../components/Modals/LBCModal";
import { useLocation, useNavigate } from "react-router-dom";
import { Button, RawButton, RawDropdown } from "../../../core/Buttons";
import { ColumnHeader } from "../../../components/Tables/ColumnHeader";
import { Text } from "../../../core/Text";
import { ImSpinner2 } from "react-icons/im";
import moment from "moment";
import { Pagination } from "../../../components/Tables/Pagination";
import axiosCAPApi from "../../../api/axiosCAPApi";
import axiosCAPApiPrivate from "../../../api/axiosCAPApiPrivate";
import NPouchRegular from "../../../assets/images/sendtipid-pckgs/N-Pouch-Regular.png";
import KiloBoxSmall from "../../../assets/images/sendtipid-pckgs/Kilobox-Small.png"
import KiloBoxMedium from "../../../assets/images/sendtipid-pckgs/Kilobox-Medium.png";
import { TrackingModal } from "../../../components/Modals/TrackingModal";
import { SendTipidBundleData } from "../../../components/Tables/DeliveryDataRow";
import { Images } from "../../../assets/images/images";

import { ResponsiveBar } from "@nivo/bar";

export const SendTipidReportsTab = ({
    reportFilter,
    reportDateFrom,
    reportDateTo,
}) => {
    const navigate = useNavigate();
    const dataFetchedRef = useRef(false);
    const { search } = useLocation();
    const query = new URLSearchParams(search);

    const [loading, setLoading] = React.useState(false);
    const [shipperAcctName, setShipperAcctName] = React.useState("");
    const [shipperAcctNo, setShipperAcctNo] = React.useState("");

    const [isToastOpen, setToastOpen] = React.useState(false);
    const [toastKind, setToastKind] = React.useState("");
    const [toastTitle, setToastTitle] = React.useState("");
    const [toastDesc, setToastDesc] = React.useState("");

    const [isToastOpen1, setToastOpen1] = React.useState(false);
    
    const [isToastOpen2, setToastOpen2] = React.useState(false);
    const [toastKind2, setToastKind2] = React.useState("");
    const [toastTitle2, setToastTitle2] = React.useState("");
    const [toastDesc2, setToastDesc2] = React.useState("");

    const [isModalOpen, setIsModalOpen] = useState(false);
    const [modalTrackingNumbers, setModalTrackingNumbers] = useState([]);

    const [filterValue, setFilterValue] = useState("24H");
    const [sendTipidBundlesData, setSendTipidBundlesData] = useState([]);
    const [sendTipidSummary, setSendTipidSummary] = useState([]);

    const cookies = new Cookies();

    const [currentPage, setCurrentPage] = useState(1);
    const [articlesPerPage] = React.useState(5);
    const [sortList, setSortList] = React.useState([]);

    const indexOfLastArticle = currentPage * articlesPerPage;
    const indexOfFirstArticle = indexOfLastArticle - articlesPerPage;
    const newItems = sendTipidBundlesData.slice(indexOfFirstArticle, indexOfLastArticle);

    const [selectedTrackingNumbers, setSelectedTrackingNumbers] = useState([]);
    const [isTrackingModalOpen, setTrackingModalOpen] = useState(false);
    const [selectedProduct, setSelectedProduct] = useState(null);


    const paginate = (pageNumber) => setCurrentPage(pageNumber);

    React.useEffect(() => {

        if (dataFetchedRef.current) return;
        dataFetchedRef.current = true;
    
        var _shipperAcct = cookies.get("shipperAcct", { path: "/" });
        var _shipperAcctSplit = _shipperAcct ? _shipperAcct.split("|") : [];
        var _shipperAcctName = _shipperAcctSplit[0]
          ? _shipperAcctSplit[0].toString().trim()
          : "";
        var _shipperAcctNo = _shipperAcctSplit[1]
          ? _shipperAcctSplit[1].toString().trim()
          : "";
    
        setShipperAcctName(_shipperAcctName);
        setShipperAcctNo(_shipperAcctNo);

        getSendTipidBundles(_shipperAcctNo);

        getSendTipidSummary(_shipperAcctNo);

    }, []);

    React.useEffect(() => {
        if (sendTipidBundlesData) {
            setSortList(sendTipidBundlesData);
        }
    }, [sendTipidBundlesData]);

    React.useEffect(() => {
        setSortList(sendTipidBundlesData || []);
    }, [sendTipidBundlesData]);

    const getSendTipidBundles = async (shipperAccountNo) => {
        setSendTipidBundlesData([]);
        setLoading(true);

        const reqData = {
            shipperAccountNo: shipperAccountNo,
            dateFilterType: 1
        }

        try {

            const response = await axiosCAPApiPrivate.post(
                "/api/SendTipidReportBundles",
                reqData
            );

            const resData = response.data;

            if (resData.Code === "200") {
                setSendTipidBundlesData(resData.Data);
                setSortList(resData.Data);
                console.log("Data: ", resData.Data);
                setLoading(false);
            } else {
                setToastKind2("info");
                setToastTitle2("Invormation");
                setToastDesc2(resData.Message);
                setTimeout(() => {
                setLoading(false);
                }, 1000);
                setTimeout(() => {
                setToastOpen2(true);
                }, 1500);
                setTimeout(() => {
                setToastOpen2(false);
                }, 5000);
            }

        } catch (error) {
            setToastKind("error");
            setToastTitle("API Fetch Failed!");
            setToastDesc(error.message);
            setTimeout(() => {
                setLoading(false);
            }, 1000);
            setTimeout(() => {
                setToastOpen(true);
            }, 1500);
            setTimeout(() => {
                setToastOpen(false);
            }, 5000);
        }
    };

    const getSendTipidSummary = async (shipperAccountNo) => {
        setSendTipidSummary(null);
        setLoading(true);

        const reqData = {
            shipperAccountNo: shipperAccountNo,
        }

        try {
            const response = await axiosCAPApiPrivate.post(
                "/api/SendTipidSummary",
                reqData
            );

            const resData = response.data;

            if (resData.Code === "200") {
                setSendTipidSummary(resData.Data[0]);
                // setSendTipidSummary(resData.Data);
                console.log("Graph Data: ", resData.Data);
                setLoading(false);
            } else {
                setToastKind2("info");
                setToastTitle2("Invormation");
                setToastDesc2(resData.Message);
                setTimeout(() => {
                setLoading(false);
                }, 1000);
                setTimeout(() => {
                setToastOpen2(true);
                }, 1500);
                setTimeout(() => {
                setToastOpen2(false);
                }, 5000);
            }
        }
        catch (error) {
            setToastKind("error");
            setToastTitle("API Fetch Failed!");
            setToastDesc(error.message);
            setTimeout(() => {
                setLoading(false);
            }, 1000);
            setTimeout(() => {
                setToastOpen(true);
            }, 1500);
            setTimeout(() => {
                setToastOpen(false);
            }, 5000);
        }
    }

    const dummyData = [
        { package: "Kilo Box Large", image: KiloBoxMedium, bundles: 10, orderDate: "2024-03-01", expirationDate: "2024-06-01", used: 3, unused: 7 },
        { package: "N-Pouch-Regular", image: NPouchRegular, bundles: 20, orderDate: "2024-02-15", expirationDate: "2024-05-15", used: 12, unused: 8 },
        { package: "Kilo Box Small", image: KiloBoxSmall, bundles: 50, orderDate: "2024-01-10", expirationDate: "2024-04-10", used: 25, unused: 25 },
    ];

    const data = [
        {
            category: "Purchased",
            value: 100,
            label: "Purchased",
            subtext: "Purchased",
            color: "#f7931e",
        },
        {
            category: "Unused",
            value: 25,
            label: "Unused",
            subtext: "Fulfilled",
            color: "#4285F4",
        },
        {
            category: "Total Bookings",
            value: 75,
            label: "Total Bookings",
            subtext: "Total Bookings",
            color: "#F44336",
        },
    ];

    const handleImageClick = (rawTrackingNumbers, usedCount, productType) => {
        console.log("Clicked product:", productType);
        console.log("Tracking numbers for this product:", rawTrackingNumbers);

        const taggedList = rawTrackingNumbers.map((num, index) => ({
            number: num,
            isUsed: index < usedCount // mark as used if within count
        }));

        // Group into rows of 2
        const groupIntoRows = (array, size) => {
            const result = [];
            for (let i = 0; i < array.length; i += size) {
                result.push(array.slice(i, i + size));
            }
            return result;
        };

        const grouped = groupIntoRows(taggedList, 2);
        setModalTrackingNumbers(grouped); // This now contains objects with isUsed
        setSelectedProduct(productType);
        setIsModalOpen(true);
    };

    let chartData = [];
    if (sendTipidSummary) {
        chartData = [
            {
                category: "Purchased",
                value: sendTipidSummary.TotalPurchase,
                label: "Purchased",
                subtext: "Purchased",
                color: "#f7931e",
            },
            {
                category: "Unused",
                value: sendTipidSummary.TotalUnused,
                label: "Unused",
                subtext: "Unused",
                color: "#4285F4",
            },
            {
                category: "Total Bookings",
                value: sendTipidSummary.TotalBookings,
                label: "Total Bookings",
                subtext: "Total Bookings",
                color: "#F44336",
            },
        ];
    }

    // const chartData = [
    //     {
    //         category: "Purchased",
    //         value: sendTipidSummary?.TotalPurchase,
    //         label: "Purchased",
    //         subtext: "Purchased",
    //         color: "#f7931e",
    //     },
    //     {
    //         category: "Unused",
    //         value: sendTipidSummary?.TotalUnused,
    //         label: "Unused",
    //         subtext: "Fulfilled",
    //         color: "#4285F4",
    //     },
    //     {
    //         category: "Total Bookings",
    //         value: sendTipidSummary?.TotalBookings,
    //         label: "Total Bookings",
    //         subtext: "Total Bookings",
    //         color: "#F44336",
    //     },
    // ];

    React.useEffect(() => {
        console.log("Graph data123:", chartData); // tingnan kung dito pa lang mali na ang value
    }, [chartData]);

    console.log("Chart Data: ", chartData);

    return (
        <>
            <LBCModal
                description={toastDesc}
                isOpen={isToastOpen}
                onClose={() => setToastOpen(false)}
                title={toastTitle}
                toastKind={toastKind}
            />

            <TrackingModal isOpen={isModalOpen} onClose={() => setIsModalOpen(false)} trackingNumbers={modalTrackingNumbers} productType={selectedProduct} shipperAccountNo={shipperAcctNo} />

            <Div className="w-full">
                <Spacer className="w-10 h-6" />

                <Div className="w-full flex justify-between items-center px-6 py-4">
                    {/* Left Section: Title & Description */}
                    <Div>
                        <Text className="text-lg font-bold text-gray-900">Reports</Text>
                        <Text className="text-gray-600 text-sm">
                            Access personalized insights, reports, and data, and monitor your performance here.
                        </Text>
                    </Div>

                    {/* Right Section: Filter with Label on Top */}
                    <Div className="flex flex-col">
                        <Text className="text-gray-500 text-sm mb-1">Dashboard Filter</Text>
                        <select className="border border-gray-300 rounded-lg px-3 py-2 text-sm text-gray-700 w-48">
                            <option>Last 24 hours</option>
                            <option>Last 7 days</option>
                            <option>Last 30 days</option>
                        </select>
                    </Div>
                </Div>

                <Spacer className="w-10 h-10" />
                {/* Header */}
                <Div className="w-full bg-[#D00149] rounded-tl-3xl rounded-tr-3xl py-3 shadow-lg">
                    <FlexRow className="w-full items-center justify-center">
                        <Text className="text-white font-bold tracking-wide uppercase">
                            SENDTIPID INVENTORY PERFORMANCE
                        </Text>
                    </FlexRow>
                </Div>

                <Spacer className="w-10 h-10" />

                <div style={{ height: "400px" }}>
                    <ResponsiveBar
                        data={chartData}
                        keys={["value"]}
                        indexBy="category"
                        margin={{ top: 60, right: 20, bottom: 60, left: 20 }}
                        padding={0.1}
                        colors={({ data }) => data.color}
                        borderRadius={10}
                        axisBottom={null}
                        axisLeft={null}
                        enableGridX={false}
                        enableGridY={false}
                        enableLabel={false}
                        tooltip={({ id, value }) => (
                            <div className="bg-black text-white p-2 rounded">
                            {id}: {value}
                            </div>
                        )}
                        layers={[
                            "grid",
                            "axes",
                            "bars",
                            ({ bars }) => (
                            <>
                                {bars.map((bar) => {
                                const { x, y, width, height, data } = bar;
                                const original = data.data;

                                return (
                                    <g key={bar.key} transform={`translate(${x},${y})`}>
                                    <text
                                        x={width / 2}
                                        y={-25}
                                        textAnchor="middle"
                                        fontSize="16"
                                        fontWeight="bold"
                                        fill="red"
                                    >
                                        {original.value}
                                    </text>

                                    <text
                                        x={width / 2}
                                        y={-5}
                                        textAnchor="middle"
                                        fontSize="13"
                                        fill="#993300"
                                    >
                                        {original.subtext}
                                    </text>

                                    <text
                                        x={width / 2}
                                        y={height + 20}
                                        textAnchor="middle"
                                        fontSize="14"
                                        fontWeight="bold"
                                        fill="black"
                                    >
                                        {original.label}
                                    </text>
                                    </g>
                                );
                                })}
                            </>
                            ),
                        ]}
                    />
                </div>

                <Spacer className="w-10 h-5" />

                {/* Table Container */}
                <Div className="w-full border border-grey-300 rounded-lg shadow-lg overflow-x-auto my-5">
                    {/* Table Header */}
                    <FlexRow className="bg-pink-100 text-gray-700 font-bold uppercase text-sm border-b border-gray-300 py-2">
                        <Text className="w-350px px-4 text-center">Package</Text>
                        {/* <Text className="w-200px text-center">Bundles</Text> */}
                        <Text className="w-200px text-center">Order Date</Text>
                        <Text className="w-200px text-center">Expiration Date</Text>
                        <Text className="w-200px text-center">Used</Text>
                        <Text className="w-200px text-center">Unused</Text>
                    </FlexRow>

                    {/* Table Body */}
                    {loading ? (
                        <Text className="text-red-400 text-center flex justify-center items-center my-20">
                            <ImSpinner2 className="animate-spin mr-2 text-2xl" />
                            Loading data...
                        </Text>
                    ) : (
                        newItems.map((item, index) => {
                            const packageImage = Images.getPackageImageSendTipid(item.ProductTypeId);

                            return (
                                <FlexRow key={index} className="items-center w-full py-3 border-b border-gray-200 hover:bg-gray-100">
                                    <Div className="w-350px flex flex-col items-center px-4">
                                        <img src={Images.getPackageImageSendTipid(item.ProductTypeId)} alt={item.ProductTypeId} className="w-16 h-16 object-contain mb-1" onClick={() => handleImageClick(item.TrackingNumbers ? item.TrackingNumbers.split(",").map((x) => x.trim()) : [], item.UsedCount, item.ProductTypeId)} />
                                        <Text className="text-gray-800 text-sm font-medium">{item.ProductType}</Text>
                                    </Div>
                                    <Text className="w-200px text-center text-gray-700">{item.OrderDate}</Text>
                                    <Text className="w-200px text-center text-gray-700">{item.ExpirationDate}</Text>
                                    <Text className="w-200px text-center text-gray-700">{item.UsedCount}</Text>
                                    <Text className="w-200px text-center text-gray-700">{item.UnusedCount}</Text>
                                </FlexRow>
                            )
                        })
                    )}
                </Div>
            </Div>
            <Text className="text-red-400 text-xs font-bold my-2">
                {`Disclaimer: Coverage is Twelve (12) months from encoded date.`}
            </Text>
            <Spacer className="w-full h-10" />
            <Div className="w-full">
                <Pagination
                    currentPage={currentPage}
                    itemsPerPage={articlesPerPage}
                    paginate={paginate}
                    totalItems={sendTipidBundlesData.length}
                />
            </Div>
        </>
    )
};